import * as lib from '../dependencies';
import * as actionTypes from '../store/actions/actionTypes';
import {
  IconOutgoingAnswered,
  IconOutgoingUnanswered,
  IconIncoming,
  IconMissed,
  IconInternalAnswered,
  IconInternalUnanswered,
  IconVoiceMail,
  IconVideoAnswered,
  IconVideoMissed,
} from '../assets/svgIcons';

export function isLocalExtension(n) {
  if (typeof n !== 'undefined') {
    const number = n.toString() || '';
    const specialNumber = /^\*/g.test(number);

    if (number.length < 5 || specialNumber) {
      return true;
    }
  }

  return false;
}

export function getCallIcon(details) {
  const { direction } = details;

  switch (direction) {
    case 'inbound':
      return {
        iconCall: IconIncoming,
      };
    case 'outbound':
      return {
        iconCall: IconOutgoingAnswered,
      };
    case 'outbound-unanswered':
      return {
        iconCall: IconOutgoingUnanswered,
      };
    case 'internal':
      return {
        iconCall: IconOutgoingAnswered,
      };
    case 'internal-answered':
      return {
        iconCall: IconInternalAnswered,
      };
    case 'internal-unanswered':
      return {
        iconCall: IconInternalUnanswered,
      };
    case 'missed':
      return {
        iconCall: IconMissed,
      };
    case 'voicemail':
      return {
        iconCall: IconVoiceMail,
      };
    case 'videoanswered':
      return {
        iconCall: IconVideoAnswered,
      };
    case 'videomissed':
      return {
        iconCall: IconVideoMissed,
      };
    default:
      return {
        iconCall: IconOutgoingAnswered,
      };
  }
}

/**
 * Format the call log item(Icon, call direction, numbers).
 * @param {Object} calllogItem - A call log item.
 * @param {String} userExtension - The current user extension.
 * @returns returns a call log object formated or null.
 */
export function getCallFormated(calllogItem, userExtension) {
  const callItem = lib._.cloneDeep(calllogItem);
  const InboundDirectionLabel = lib.i18n.t('helpers.call.inbound');
  const OutboundDirectionLabel = lib.i18n.t('helpers.call.outbound');
  const OutboundUnansweredDirectionLabel = lib.i18n.t(
    'helpers.call.outboundUnanswered'
  );
  const MissedDirectionLabel = lib.i18n.t('helpers.call.missed');
  const VoicemailDirectionLabel = lib.i18n.t('helpers.call.voicemail');
  const InternalAnsweredDirectionLabel = lib.i18n.t(
    'helpers.call.internalAnswered'
  );
  const InternalUnansweredDirectionLabel = lib.i18n.t(
    'helpers.call.internalUnanswered'
  );
  const InternalVideoCallAnswered = lib.i18n.t(
    'helpers.call.internalVideoCallAnswered'
  );
  const InternalVideoCallMissed = lib.i18n.t(
    'helpers.call.internalVideoCallMissed'
  );

  if (callItem && userExtension) {
    const isUnansweredOrBusy =
      callItem.status === 'NO ANSWER' || callItem.status === 'BUSY';

    switch (callItem.direction) {
      case 'inbound':
        callItem.from = String(callItem.fromLocal || callItem.from);
        callItem.fromName = String(
          callItem.fromContactName || callItem.fromName || callItem.fromExtName
        );
        callItem.to = String(callItem.toLocal || callItem.to);
        callItem.toName = String(
          callItem.toContactName || callItem.toName || callItem.toExtName
        );
        callItem.directionLabel = InboundDirectionLabel;
        callItem.directionNumber = 2;
        break;
      case 'outbound':
        callItem.from = String(callItem.fromExt || callItem.fromLocal);
        callItem.fromName = String(callItem.fromExtName || callItem.fromName);
        callItem.to = String(callItem.toLocal || callItem.to);
        callItem.direction = isUnansweredOrBusy
          ? 'outbound-unanswered'
          : 'outbound';
        callItem.directionLabel = isUnansweredOrBusy
          ? OutboundUnansweredDirectionLabel
          : OutboundDirectionLabel;
        callItem.directionNumber = 3;
        break;
      case 'internal':
        if (userExtension && userExtension === callItem.fromExt) {
          callItem.from = String(callItem.fromExt);
        } else {
          callItem.from = String(
            callItem.fromLocal || callItem.from || callItem.fromExt
          );
        }

        callItem.fromName = String(callItem.fromExtName);
        callItem.to = String(callItem.toLocal || callItem.to || callItem.toExt);
        callItem.toName = String(callItem.toExtName);
        callItem.direction = isUnansweredOrBusy
          ? 'internal-unanswered'
          : 'internal-answered';
        callItem.directionLabel = isUnansweredOrBusy
          ? InternalUnansweredDirectionLabel
          : InternalAnsweredDirectionLabel;
        callItem.directionNumber = 1;
        break;
      default:
    }

    // Treat the missed call.
    if (
      callItem &&
      (callItem.status === 'NO ANSWER' ||
        callItem.status === 'BLOCKED' ||
        callItem.status === 'BUSY') &&
      callItem.direction !== 'outbound' &&
      callItem.direction !== 'outbound-unanswered' &&
      callItem.direction !== 'outgoing' &&
      callItem.direction !== 'internal-answered' &&
      callItem.direction !== 'internal-unanswered'
    ) {
      callItem.direction = 'missed';
      callItem.directionLabel = MissedDirectionLabel;
      callItem.directionNumber = 1;
    }

    // Treat the Voicemail.
    if (callItem && callItem.lastApp === 'VoiceMail') {
      callItem.direction = 'voicemail';
      callItem.directionLabel = VoicemailDirectionLabel;
      callItem.directionNumber = 2;
    }

    // Video call
    if (callItem && callItem.lastApp === 'INTERNAL_VIDEO_ANSWERED') {
      callItem.direction = 'videoanswered';
      callItem.directionLabel = InternalVideoCallAnswered;
    }

    if (callItem && callItem.lastApp === 'INTERNAL_VIDEO_MISSED') {
      callItem.direction = 'videomissed';
      callItem.directionLabel = InternalVideoCallMissed;
    }

    // Get call direction definition
    const { iconCall } = getCallIcon(callItem);
    callItem.icon = iconCall;

    return callItem;
  }

  return null;
}

// Should returns the corrent display callee names
export function getCalleeName(calleeName) {
  if (calleeName) {
    const calleeNameArr = String(calleeName)
      .toLowerCase()
      .split('');

    // In order to make sure is characters
    const checker = 'abcdefghijklmnopqrstuvxzwy';
    let count = 0;

    // for (const char of calleeNameArr) {
    //   if (checker.includes(char)) {
    //     count += 1;
    //   }
    // }

    calleeNameArr.forEach(char => {
      if (checker.includes(char)) {
        count += 1;
      }
    });

    if (count >= 2) {
      // adjusting long names on displaying
      if (calleeNameArr.length >= 15) {
        return `${calleeName.slice(0, 15)}...`;
      }
      return calleeName;
    }

    return null;
  }
  return null;
}

export function isInbound(direction) {
  if (/inbound|missed|voicemail/.test(direction)) {
    return true;
  }
  return false;
}

/**
 * Validation for internal extension number, it returns true for extesions.
 * @param {String} num - An GSM or internal/external number
 * @returns returns false for invalid null or undefined params
 */
export function isExtension(num) {
  if (num) {
    const str = String(num);
    if (str?.length < 5) {
      return true;
    }
    return false;
  }
  return false;
}

/**
 * Validation wether a given number is anonymous or not.
 * @param {String | Number} phoneNumber - An phone number
 * @returns return True when phonenumber is not anonymous
 */
export function isNotAnonymous(phoneNumber) {
  if (
    phoneNumber &&
    phoneNumber !== 'anonymous' &&
    !String(phoneNumber).includes('35312546124')
  )
    return true;
  return false;
}

// ua.invite(target, ...) required espefic number typing
export function isValidInviteTarget(number) {
  const regexp = RegExp(/^[+,*,#]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/, 'g');
  if (regexp.test(number)) {
    return true;
  }
  return false;
}

/**
 * Returns calllogs filtered by phone number
 * @param {Array} calllogs - An array of call logs as reducer structure
 * @param {String} phonenumber - A string phone number or extension
 */
export function getCallLogsByPhoneNumber(calllogs, phonenumber) {
  if (
    !typeof calllogs === 'object' ||
    !typeof phonenumber === 'string' ||
    !calllogs.length ||
    !phonenumber
  ) {
    return [];
  }

  const numberParser = n => {
    return String(n)
      .split(/[\s+]/)
      .join('');
  };

  const data = [];

  if (isExtension(phonenumber)) {
    lib._.forEach(calllogs, callsForDate => {
      const foundOne = lib._.filter(callsForDate.data, c => {
        return (
          lib._.isEqual(numberParser(c.from), phonenumber) ||
          lib._.isEqual(numberParser(c.to), phonenumber)
        );
      });
      if (foundOne && foundOne.length) {
        data.push(...foundOne);
      }
    });
  } else {
    const numberPiece =
      phonenumber.length <= 7
        ? numberParser(phonenumber)
        : numberParser(phonenumber).slice(-7);

    lib._.forEach(calllogs, callsForDate => {
      const foundOne = lib._.filter(callsForDate.data, c => {
        return (
          lib._.includes(numberParser(c.from), numberPiece) ||
          lib._.includes(numberParser(c.to), numberPiece)
        );
      });
      if (foundOne && foundOne.length) {
        data.push(...foundOne);
      }
    });
  }
  const newValues = [{ data }];
  return newValues.reduce((prev, next) => prev.concat(next.data), []);
}

/**
 * Returns calllogs grouped by call date
 * @param {Array} callLogs - An array of call logs as reducer structure
 * @example
 * ```
 * Input: [{ title: 'Fri 23 April, data: [{},...] }, {}...]
 * Output: [{ 'Today Fri 23 April': Array(1)}]
 * ```
 */
export function getCalllogsGroupInfo(calllogs) {
  const callLogsFormatted = calllogs.map(values => ({
    ...values,
    callDateFormatted:
      lib.dayjs(values.callDate).format('ddd DD MMMM') ===
      lib.dayjs(new Date()).format('ddd DD MMMM')
        ? `Today ${lib.dayjs(values.callDate).format('ddd DD MMMM')}`
        : `${lib.dayjs(values.callDate).format('ddd DD MMMM')}`,
  }));

  const calllogsGrouped = lib
    ._(callLogsFormatted)
    .groupBy(o => o.callDateFormatted)
    .value();

  if (lib._.isObject(calllogsGrouped) && !lib._.isEmpty(calllogsGrouped)) {
    const groupCounts = Object.values(calllogsGrouped).map(i => i.length);
    const groups = Object.keys(calllogsGrouped);

    return {
      groupCounts,
      groups,
    };
  }

  return {};
}

/**
 * Returns a translated call description base on status e.g: CALL_FINISHED === Call Finished
 * @param {String} status - An call status string as describle on actionTypes
 */
export function getDescriptiveCallStatus(status) {
  let description;

  switch (status) {
    case actionTypes.CALL_IN_PROGRESS:
      description = lib.i18n.t('helpers.call.connected');
      break;
    case actionTypes.CALL_INCOMING:
      description = lib.i18n.t('helpers.call.connecting');
      break;
    case actionTypes.CALL_OUTGOING:
      description = lib.i18n.t('helpers.call.calling');
      break;
    case actionTypes.CALL_FINISHED:
      description = lib.i18n.t('helpers.call.callFinished');
      break;
    case actionTypes.CALL_CANCELED:
      description = lib.i18n.t('helpers.call.callCanceled');
      break;
    case actionTypes.CALL_HOLD:
      description = lib.i18n.t('helpers.call.callOnHold');
      break;
    case actionTypes.CALL_TRANSFERED:
      description = lib.i18n.t('helpers.call.callTransferred');
      break;
    case actionTypes.CALL_REJECTED:
      description = lib.i18n.t('helpers.call.callRejected');
      break;
    case actionTypes.CALL_CONFERENCE:
      description = lib.i18n.t('helpers.call.callInConference');
      break;
    default:
      description = lib.i18n.t('helpers.call.callInProgress');
      break;
  }
  return description;
}

/**
 * Find and return an extesion name from an extension list.
 * @param {Array} list - A list of extesions information
 * @param {String} number - A number/extesion to be filtered
 */
export function getExtName(list, number) {
  if (!list || !number) return null;

  const extensionInfo = list.find(ext => Number(ext.number) === Number(number));

  if (extensionInfo?.name) {
    return extensionInfo.name;
  }

  return null;
}

export function isNumeric(str) {
  // Use a regular expression to check if the string contains only digits
  const numericRegex = /^[0-9]+$/;
  return numericRegex.test(str);
}
